import { useEffect, useState } from "react";
import { detectBrandByDomain } from "../services/brandApi";

export interface UseDetectedBrandSlugResult {
  slug: string | null;
  isLoading: boolean;
  /** True when `GET /brands/detect` failed — callers decide the fallback (no swallowing). */
  isError: boolean;
}

/**
 * Resolves the current domain's brand slug via the backend-resolved
 * `GET /brands/detect`. Separate from `useDetectedBrandLegal` (legal URLs
 * and versions) so the registration route can branch on the brand without
 * touching the legal hook's consumers.
 */
export function useDetectedBrandSlug(): UseDetectedBrandSlugResult {
  const [state, setState] = useState<UseDetectedBrandSlugResult>({
    slug: null,
    isLoading: true,
    isError: false,
  });

  useEffect(() => {
    let cancelled = false;
    detectBrandByDomain(window.location.hostname)
      .then((brand) => {
        if (!cancelled) {
          setState({
            slug: brand.slug ?? null,
            isLoading: false,
            isError: false,
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ slug: null, isLoading: false, isError: true });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
